<template>
    <v-col class="w100p">
        <v-card class="flex pa-0 round-card background-2 elevation-0">
            <v-card-title class="pa-3">
                <p>Checklist</p>
                <v-btn small icon class="ml-4" @click="addChecklist()">
                    <v-icon dark>add</v-icon>
                </v-btn>
            </v-card-title>
            <div class="checklist-items px-12 pb-4" v-if="showAddChecklist">
                <v-text-field
                    label="Nuova Checklist"
                    v-model="new_checklist"
                    single-line
                    hide-details
                    outlined
                    text
                    @keydown.enter="createChecklist()"
                    dense
                    >
                    <template v-slot:append>
                        <v-btn small icon @click="createChecklist()">
                            <v-icon color="grey lighten-1" dark>add</v-icon>
                        </v-btn>
                    </template>
                </v-text-field>					
            </div>
            <template v-for="(checklist, c) in model.checklists">
                <v-card :key="c" elevation="0" class="pb-4 background-2">
                    <v-list class="pa-0 background-2">
                        <v-list-item>
                            <v-list-item-content class="pa-0">
                                <div class="checklist-name">
                                    <v-text-field
                                        v-model="checklist.name"
                                        single-line
                                        hide-details
                                        prepend-icon="assignment"
                                        text>
                                    </v-text-field>	
                                </div>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-menu offset-y :min-width="150" style="height: 100%; margin: auto" transition="fade-transition" nudge-left="100">
                                    <template v-slot:activator="{ on }">							
                                        <v-btn small icon v-on="on">
                                            <v-icon>more_vert</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense class="background-2">
                                        <v-list-item @click="deleteChecklist(c)">
                                            <v-list-item-title>Elimina Checklist</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                    <div class="pl-12 pr-4 pb-2" style="display: flex">
                        <span style="margin: auto; display: -webkit-inline-box;">
                            <strong class="mx-4 text-no-wrap">
                                    {{ completedItems(c) }} / {{ lengthItems(c) }}
                            </strong>
                        </span>
                        <v-progress-linear :value="progressItems(c)" height="4" class="margin-auto"></v-progress-linear>
                    </div>
                    <v-slide-y-transition
                        class="py-0 pl-12"
                        group
                        tag="div"
                        >
                        <div :key="c">
                            <template v-for="(checklist_item, i) in checklist.checklistitems">
                                <div class="checklist-items" :key="i">
                                    <v-text-field
                                        single-line
                                        hide-details
                                        outlined
                                        dense
                                        text
                                        v-model="checklist_item.name">
                                        <template v-slot:prepend-inner>
                                            <v-checkbox v-model="checklist_item.done" color="primary" hide-details></v-checkbox>
                                        </template>
                                        <template v-slot:append>
                                            <v-scroll-x-transition>
                                                <v-icon v-if="checklist_item.done" color="success">check</v-icon>
                                            </v-scroll-x-transition>
                                            <v-btn small icon @click="deleteChecklistItem(c, i)">
                                                <v-icon color="grey lighten-1" dark>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-text-field>
                                </div>
                            </template>
                            <div class="checklist-items">
                                <v-text-field
                                    label="Nuovo checklist item"
                                    v-model="new_checklist_item[c]"
                                    single-line
                                    hide-details
                                    outlined
                                    text
                                    dense
                                    @keydown.enter="createChecklistItem(c)"
                                    >
                                    <template v-slot:append>
                                        <v-btn small icon @click="createChecklistItem(c)">
                                            <v-icon color="grey lighten-1" dark>add</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>					
                            </div>
                        </div>
                    </v-slide-y-transition>
                </v-card>
            </template>
        </v-card>
    </v-col>
</template>

<script>

import Vue from 'vue'

export default {
	name: 'checklist-task',
	props: {
		model: Object,
	},

	data() {
		return {
			new_checklist: '',
			showAddChecklist: false,
			new_checklist_item: {},
		}
	},

	computed: {

		completedItems(checklistIndex) {
        		return (checklistIndex) => {
				if(this.model.checklists[checklistIndex].checklistitems) {
					return this.model.checklists[checklistIndex].checklistitems.filter(item => item.done).length
				} else {
					return 0
				}
			}
		},
			  
		progressItems(checklistIndex) {
        		return (checklistIndex) => {
				if(this.model.checklists[checklistIndex].checklistitems) {
					return this.completedItems(checklistIndex) / this.model.checklists[checklistIndex].checklistitems.length * 100
				} else {
					return 0
				}
			} 
			  },
			  
		lengthItems(checklistIndex) {
        		return (checklistIndex) => {
				if(this.model.checklists[checklistIndex].checklistitems) {
					return this.model.checklists[checklistIndex].checklistitems.length
				} else {
					return 0
				}
			} 
      		},
	},

	methods: {

		addChecklist() {
			this.showAddChecklist = true
		},

		createChecklist() {
			if(this.new_checklist != '') {
				if(typeof this.model.checklists === 'undefined') {
					Vue.set(this.model, 'checklists', [])
				}
				this.model.checklists.push({name: this.new_checklist})
				this.new_checklist = ''
				this.showAddChecklist = false
			}
		},

		deleteChecklist(index) {
			this.model.checklists.splice(index, 1)
		},

		createChecklistItem(index) {
			if(this.new_checklist_item[index]) {
				if(typeof this.model.checklists[index].checklistitems === 'undefined') {
					Vue.set(this.model.checklists[index], 'checklistitems', [])
				}
				this.model.checklists[index]['checklistitems'].push({name: this.new_checklist_item[index]})
				this.new_checklist_item[index] = ''
			}
		},

		deleteChecklistItem(checklistIndex, itemIndex) {
			this.model.checklists[checklistIndex].checklistitems.splice(itemIndex, 1)
		}
	},


	created() {

	},

	mounted() {

	}
}
</script>

<style>

</style>
